import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=6495bb17&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6495bb17')) {
      api.createRecord('6495bb17', component.options)
    } else {
      api.reload('6495bb17', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=6495bb17&", function () {
      api.rerender('6495bb17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ef95sz9CSqZp/JS/offershelp.vue"
export default component.exports